/**
 * Tab definitions for boosting subscription UI (sub-nav + seller subscription labels).
 * Keys must match `getGameFromPath()` first path segment (game slug).
 */

const boostingSubscriptionServiceTypesByGame = {
  'league-of-legends': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'placement-boost', label: 'Placement Boost' },
    { id: 'net-wins', label: 'Net Wins' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'league-of-legends-wild-rift': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'legendary-queue', label: 'Legendary Queue' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'blox-fruits': [
    { id: 'power-leveling', label: 'Power Leveling' },
    { id: 'quests-and-gear', label: 'Quests & Gear' },
    { id: 'raids', label: 'Raids' },
    { id: 'currency-and-points', label: 'Currency & Points' },
    { id: 'fighting-styles', label: 'Fighting Styles' },
    { id: 'mastery-upgrades', label: 'Mastery Upgrades' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'cod-call-of-duty': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'camos-unlock', label: 'Camos Unlock' },
    { id: 'zombies-quests', label: 'Zombies Quests' },
    { id: 'bot-lobbies', label: 'Bot Lobbies' },
    { id: 'warzone-wins', label: 'Warzone Wins' },
    { id: 'battle-pass', label: 'Battle Pass' },
    { id: 'prestige-leveling', label: 'Prestige Leveling' },
    { id: 'weapons-leveling', label: 'Weapons Leveling' },
    { id: 'power-leveling', label: 'Power Leveling' },
    { id: 'kd-boost', label: 'KD Boost' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'clash-of-clans': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'resources-farm', label: 'Resources Farm' },
    { id: 'wall-upgrades', label: 'Wall Upgrades' },
    { id: 'clan-games', label: 'Clan Games' },
    { id: 'heroes-leveling', label: 'Heroes Leveling' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'black-desert-online': [
    { id: 'power-leveling', label: 'Power Leveling' },
    { id: 'silver-farming', label: 'Silver Farming' },
    { id: 'life-skills', label: 'Life Skills' },
    { id: 'dungeons', label: 'Dungeons' },
    { id: 'quests', label: 'Quests' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'escape-from-tarkov': [
    { id: 'power-leveling', label: 'Power Leveling' },
    { id: 'raids', label: 'Raids' },
    { id: 'quests', label: 'Quests' },
    { id: 'prestige-leveling', label: 'Prestige Leveling' },
    { id: 'hideout-upgrade', label: 'Hideout Upgrade' },
    { id: 'currency-farm', label: 'Currency Farm' },
    { id: 'market-unlock', label: 'Market Unlock' },
    { id: 'boss-kills', label: 'Boss Kills' },
  ],
  battlefield: [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'weapon-leveling', label: 'Weapon Leveling' },
    { id: 'bot-lobbies', label: 'Bot Lobbies' },
    { id: 'challenges-boost', label: 'Challenges Boost' },
    { id: 'redsec-wins', label: 'Redsec Wins' },
    { id: 'battle-pass', label: 'Battle Pass' },
    { id: 'vehicle-leveling', label: 'Vehicle Leveling' },
    { id: 'dog-tags', label: 'Dog Tags' },
    { id: 'achievements-and-trophies', label: 'Achievements & Trophies' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'dead-by-daylight': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'bloodpoints', label: 'Bloodpoints' },
    { id: 'iridescent-shards', label: 'Iridescent Shards' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'delta-force': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'raids', label: 'Raids' },
    { id: 'quests', label: 'Quests' },
    { id: 'number-of-wins', label: 'Number of Wins' },
    { id: 'game-mode-leveling', label: 'Game Mode Leveling' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'the-first-descendant': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'raids', label: 'Raids' },
    { id: 'quests', label: 'Quests' },
    { id: 'number-of-wins', label: 'Number of Wins' },
    { id: 'game-mode-leveling', label: 'Game Mode Leveling' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'destiny-2': [
    { id: 'power-leveling', label: 'Power Leveling' },
    { id: 'raids', label: 'Raids' },
    { id: 'dungeons', label: 'Dungeons' },
    { id: 'portal-farming', label: 'Portal Farming' },
    { id: 'quests', label: 'Quests' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'diablo-4': [
    { id: 'power-leveling', label: 'Power Leveling' },
    { id: 'altars-of-lilith', label: 'Altars of Lilith' },
    { id: 'mythic-prankster', label: 'Mythic Prankster' },
    { id: 'paragon-leveling', label: 'Paragon Leveling' },
    { id: 'boss-kills', label: 'Boss Kills' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'dota-2': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'net-wins', label: 'Net Wins' },
    { id: 'calibration-boost', label: 'Calibration Boost' },
    { id: 'hero-tier-boost', label: 'Hero Tier' },
    { id: 'behavior-score-boost', label: 'Behavior Score Boost' },
    { id: 'custom', label: 'Custom Request' },
  ],
  fisch: [
    { id: 'power-leveling', label: 'Power Leveling' },
    { id: 'rod-services', label: 'Rod Services' },
    { id: 'unlock-services', label: 'Unlock Services' },
    { id: 'quests', label: 'Quests' },
    { id: 'money-farming', label: 'Money Farming' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'genshin-impact': [
    { id: 'power-leveling', label: 'Power Leveling' },
    { id: 'resource-boosting', label: 'Resource Boosting' },
    { id: 'explorations', label: 'Explorations' },
    { id: 'primogems-farming', label: 'Primogems Farming' },
    { id: 'custom', label: 'Custom Request' },
  ],
  donutsmp: [
    { id: 'building-service', label: 'Building Service' },
    { id: 'afk-service', label: 'Afk Service' },
    { id: 'area-digging', label: 'Area Digging' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'mobile-legends': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'net-wins', label: 'Net Wins' },
    { id: 'achievements', label: 'Achievements' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'new-world': [
    { id: 'power-leveling', label: 'Power Leveling' },
    { id: 'expertise', label: 'Expertise' },
    { id: 'trade-skills', label: 'Trade Skills' },
    { id: 'expeditions', label: 'Expeditions' },
    { id: 'weapon-mastery', label: 'Weapon Mastery' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'overwatch-2': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'placement-matches', label: 'Placement Matches' },
    { id: 'net-wins', label: 'Net Wins' },
    { id: 'stadium-rank-boost', label: 'Stadium Rank Boost' },
    { id: 'hero-skill-rating', label: 'Hero Skill Rating' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'rainbow-six-siege-x': [
    { id: 'rank-boost', label: 'Rank Boost' },
    { id: 'net-wins', label: 'Net Wins' },
    { id: 'leveling-boost', label: 'Leveling Boost' },
    { id: 'badges-boost', label: 'Badges Boost' },
    { id: 'coaching', label: 'Coaching' },
    { id: 'renown-boosting', label: 'Renown Boosting' },
    { id: 'battle-pass', label: 'Battle Pass' },
    { id: 'custom', label: 'Custom Request' },
  ],
  'world-of-warcraft': [
    { id: 'power-leveling', label: 'Power Leveling' },
    { id: 'raids', label: 'Raids' },
    { id: 'mythic-plus-dungeon-boosting', label: 'Mythic+ Dungeon Boosting' },
    { id: 'gear', label: 'Gear' },
    { id: 'pvp', label: 'PvP' },
    { id: 'twilights-blade-insignia-farm', label: "Twilight's Blade Insignia Farm" },
    { id: 'delves', label: 'Delves' },
    { id: 'housing', label: 'Housing' },
    { id: 'achievements-and-titles', label: 'Achievements & Titles' },
    { id: 'custom', label: 'Custom Request' },
  ],
};

export function getBoostingSubscriptionServiceTypes(gameSlug) {
  if (!gameSlug) return [{ id: 'custom', label: 'Custom Request' }];
  const key = String(gameSlug).toLowerCase();
  return boostingSubscriptionServiceTypesByGame[key] || [{ id: 'custom', label: 'Custom Request' }];
}
